import { createFileRoute } from '@tanstack/react-router';

import { BookSearchClaimable } from '@/module/Author/Book/BookSearchClaimable';

export const Route = createFileRoute('/_auth/author/_author/book/_book/search-claimable')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  return <BookSearchClaimable />;
}
